<!--hlsPlayer  -->
<template>
    <div class="cam" style="background-color: #000;text-align: center;width:100%;">
        <div class="video" v-show="isPlay" ref="camDOMidRef" :id="camDOMid"></div>
    </div>
</template>

<script>
    import 'xgplayer';
    import hlsjsPlayer from 'xgplayer-hls';
    export default {
        name: "hlsPlayer",
        components: {},
        props: {
            camDOMid: {type: String},
            width: {type: String},
            height: {type: String},
            videoUrl:{type: String},
            controls:{
                type: Boolean,
                default:true
            },
            limitReloadCount:{
                type: Number,
                default:10,
            },
            poster:{
                type:String,
                default:require('@/assets/images/video_empty.jpg')
            },
            voice:{
                type: Boolean,
                default:true,
            },
            id:{
                type: String,
                default:'1'
            },
            serverUrl:{
                type: String,
                default:''
            },
        },
        data() {
            return {
                isPlay: false, //是否显示播放画面
                player: null, //播放实例
                lastDecodedFrame: 0, //最后一个decodedFrame
                videoHeight:750,
                videoWidth:document.documentElement.clientWidth-302,
                sameCount: 0, //decodedFrame不变次数
                currentTime: 0, //当前时间
                lastCurrentTime: 0, //最后的时间
                timer: "", //定时器
            }
        },
        computed: {

        },
        watch: {
            //监听videoUrl变化，改变播放地址
            videoUrl: {
                handler(newval) {
                    this.player.src = this.playUrl(newval)
                }
            }
        },
        created() {


        },

        mounted() {
            //获取数据，连接
            this.getData(this.videoUrl);
            //检测网络连接，销毁重连
            let _this = this;
            window.addEventListener("online", () => {
                if (_this.player) {
                    _this.currentTime = 0;
                    _this.lastCurrentTime = 0;
                    _this.player.destroy(); //销毁 
                    _this.getData() //重连
                }
            });
            //12小时后，销毁重连
            setTimeout(() => {
                console.log("12小时后，销毁重连");
                if (_this.player) {
                    _this.currentTime = 0;
                    _this.lastCurrentTime = 0;
                    _this.player.destroy(); //销毁 
                    _this.getData() //重连
                }
            }, 12 * 60 * 60 * 1000);
        },
        methods: {
            setCurrentTime(timeDeviationSec){
                if(this.keyIframeOffset.indexOf(timeDeviationSec) > -1){
                    this.player.currentTime = timeDeviationSec;
                    this.isPlay = false
                }else{
                    this.$message({
                        type: 'error',
                        message: '无效关键帧，无法定位。'
                    })
                }
            },
            // 设置视频配置(注意：initPlayer应放在异步函数里或mounted之后，不可在created里直接加载，否则不生效)
            initPlayer(url) {
                this.isPlay = true;
                this.$nextTick(function () {
                    let _this = this;
                    this.player = new hlsjsPlayer({
                        id: this.camDOMid,
                        url: url,
                        autoplay: true,
                        playsinline: true,
                        autoplayMuted: true, //自动播放静音，设置自动播放参数必要参数
                        volume: 0,
                        poster:this.poster,
                        height:this.height || this.videoHeight,
                        width: this.width || this.videoWidth,
                        errorTips: `视频播放失败，请刷新页面重试。`,
                        defaultMuted: true,
                        screenShot: false,
                        aspectRatio: '16:9',
                        // errorTips: '<span class="app-error">无视频源</span>',
                    });
                    // this.player.once('canplay', () => {
                    //     // this.player.currentTime = 25594
                    // })
                    // this.player.once('error', () => {
                    //     if (this.player) {
                    //         this.player.replay();
                    //     }
                    //     return;
                    // })
                    // this.player.once('pause', () => {
                    //     // console.log('pause')
                    // })
                    // this.player.once('canplaythrough', () => {
                    //     console.log('可流畅播放')
                    //     this.player.currentTime = this.lastCurrentTime
                    // })
                    //
                    // //检测画面是否卡死。如果decodedFrames不再发生变化,就销毁掉该实例并进行重新连接。这个函数基本是1秒执行一次的。
                    // this.player.on("statistics_info", function (res) {
                    //     if (_this.lastDecodedFrame == 0) {
                    //         _this.lastDecodedFrame = res.decodedFrames;
                    //         return;
                    //     }
                    //     if (_this.lastDecodedFrame != res.decodedFrames) {
                    //         _this.lastDecodedFrame = res.decodedFrames;
                    //         _this.lastCurrentTime = _this.player.currentTime; //最后的时间
                    //         _this.sameCount = 0;
                    //     } else {
                    //         _this.sameCount++;
                    //         console.log("decodedFrames没有发生变化第", _this.sameCount, "次。时间：", new Date());
                    //
                    //         if (_this.sameCount > 9) {
                    //             //decodedFrames10次不变，则判断为画面卡死，销毁实例进行重连
                    //             console.log("画面卡死，进行重连————————", "时间", new Date());
                    //             _this.lastDecodedFrame = 0;
                    //             _this.sameCount = 0;
                    //
                    //             if (_this.player) {
                    //                 _this.currentTime = 0;
                    //                 _this.lastCurrentTime = 0;
                    //                 _this.player.destroy(); //销毁
                    //                 _this.getData() //重连
                    //             }
                    //         }
                    //     }
                    //     // console.log("最后的时间：", _this.lastCurrentTime, "   10秒前的时间：",_this.currentTime);
                    // });
                    //优化延迟
                    // setTimeout(() => {
                    //   setInterval(() => {
                    //     console.log("缓冲区末尾",this.player.getBufferedRange()[1],"当前位置：",this.player.currentTime);
                    //     if(this.player.getBufferedRange()[1]){
                    //       let end = this.player.getBufferedRange()[1];
                    //       let diff = end - this.player.currentTime;//获取buffered与currentTime的差值
                    //       if (diff >= 1) {//如果差值大于等于3 手动跳帧 这里可根据自身需求来定
                    //         this.player.currentTime = this.player.getBufferedRange()[1];//手动跳帧
                    //         console.log("优化延迟，手动跳帧，时间：",new Date());
                    //       }
                    //     }
                    //   }, 2000); //2000毫秒执行一次
                    // }, 3000);

                })
            },
            //获取数据，连接
            getData() {
                let playUrl = this.playUrl(this.videoUrl)
                this.initPlayer(playUrl)
            },
            //拼接地址
            playUrl(val) {
                // var webSocketUrl = config.webSocket; //webSocket的ip
                // let playUrl = "ws://" + webSocketUrl + "/live?url=" + val; //播放地址
                return val;
            },
            play(){ //播放
                if(this.player){
                    this.player.play();
                }
            },
            pause(){ // 暂停
                if(this.player){
                    this.player.pause();
                }
            },

        },
        beforeDestroy() {
            clearInterval(this.timer)
            if (this.player) {
                this.player.destroy();
            }
            //销毁监听
            let _this = this;
            window.removeEventListener('online', () => {
                if (_this.player) {
                    _this.currentTime = 0;
                    _this.lastCurrentTime = 0;
                    _this.player.destroy(); //销毁 
                    _this.getData() //重连
                }
            }, true);
        },

    }

</script>
<style lang="less" scoped>
</style>
<style lang="less">
    .video {
        width: 100%;
        height: 100%;
    }

</style>

